import { post } from 'axios'
import store from '../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function registerPostulantEnglishPromotion (pFormData) {
    const URI = `${BASE_URL}/api/postulant/register-english-promotion`
    return post(URI, pFormData, { headers })
}

export { registerPostulantEnglishPromotion }